import { environment } from '../environments/environment';

export const AppConfig = {
  ...environment,
  defaultAvatar: 'assets/img/svg/logo_circle.png',
  appVersion: '1.0.1.1',
};

